import * as React from "react";

const Rename = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer19"
      strokeDashoffset="22.224"
      strokeLinecap="round"
      strokeWidth="0.4"
    >
      <path
        id="rect96"
        fill="none"
        stroke="#000"
        d="M5.82 2.492v1.366a.64.64 135 0 1-.64.64H1.17a.64.64 45 0 1-.64-.64V2.492a.64.64 135 0 1 .64-.64h4.01a.64.64 45 0 1 .64.64z"
        opacity="1"
      ></path>
      <rect
        id="rect97"
        width="1.058"
        height="3.704"
        x="1.587"
        y="1.323"
        fill="#fff"
        fillOpacity="1"
        stroke="none"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        opacity="1"
        rx="2.348"
        ry="0"
      ></rect>
      <path
        id="path96"
        fill="none"
        fillOpacity="1"
        stroke="#000"
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeOpacity="1"
        d="M2.117 1.323v3.704"
        opacity="1"
      ></path>
    </g>
  </svg>
);

export default Rename;
